import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RenderableMenu } from '@rocksoft/cdk';
import { combineLatest, concat, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'era-menus',
  templateUrl: './menus.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, AsyncPipe],
})
export class MenusComponent {
  readonly menus = input.required<RenderableMenu[]>();

  public isActiveOrLastMatched$(menu: RenderableMenu): Observable<boolean> {
    const hasChildren$ = concat(of(null), menu.children$.pipe(map((children) => children && children.length > 0)));

    return combineLatest([hasChildren$, menu.isMatched$, menu.isActive$]).pipe(
      map(([hasChildren, isMatched, isActive]) => isMatched || (!hasChildren && isActive))
    );
  }
}
